import type { CartType, PromoKeys } from '@/store/types/cart'

// we can add logic here to handle the other arrays like promo..
export const getEmptyCarts = (cart: CartType) => {
  const typeToUpdate: PromoKeys[] = []
  if (cart.otp.length === 0 && cart.otpPromo && cart.otpPromo.length > 0) {
    typeToUpdate.push('otpPromo')
  }
  if (
    cart.subscribe.length === 0 &&
    cart.subscribePromo &&
    cart.subscribePromo.length > 0
  ) {
    typeToUpdate.push('subscribePromo')
  }
  return typeToUpdate
}
